import {requestBase, requestOrder, requestPayment} from "@/utils/request"

// 结算列表
export function getSettleList(data) {
  return requestOrder({
    url: '/order/shelf/selectSettlePage',
    method: 'post',
    data
  })
}

// 结算详情
export function settleOrderInfo(data) {
  return requestOrder({
    url: '/order/shelf/settleOrderInfo',
    method: 'post',
    data
  })
}

// 结算周期配置  获取列表
export function getSettlementCycle(data) {
  return requestBase({
    url: '/settlementCycle/findByYear',
    method: 'post',
    data
  })
}

// 根据结算周期导出结算列表Excel
export function exportShopSettleList(data) {
  return requestOrder({
    url: '/order/shelf/exportShopSettleList',
    method: 'post',
    data
  })
}

// 分页查询扣款记录
export function getDeductionList(data) {
  return requestPayment({
    url: '/deductionRecord/page',
    method: 'post',
    data
  })
}

// 预估欠款记录
export function estimatedRevenuePage(data) {
  return requestOrder({
    url: '/order/shelf/estimatedRevenuePage',
    method: 'post',
    data
  })
}

// 预估欠款记录详情
export function estimatedRevenueInfo(data) {
  return requestOrder({
    url: '/order/shelf/estimatedRevenueInfo',
    method: 'post',
    data
  })
}

// 当前货架需要平账的金额
export function needsReconciliationAmount(data) {
  return requestOrder({
    url: '/order/shelf/needsReconciliationAmount',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/settlement.js